
import { defineComponent } from 'vue'
import { getDefaultAvatar } from '~/utils/ui'
import { shortenLargeNumber } from '~/utils/string'

export default defineComponent({
  name: 'TeamProfile',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true
    },
    login: {
      type: String,
      required: true
    },
    avatar: {
      type: String,
      required: true
    },
    membersCount: {
      type: [String, Number],
      required: true
    }
    // TODO enable once adminCount query is added
    // adminCount: {
    //   type: [String, Number],
    //   required: true
    // }
  },
  methods: { getDefaultAvatar, shortenLargeNumber }
})
